export enum RequestVerificationCodeType {
  ACCESS_REQUEST_EMAIL_VERIFICATION = 'ACCESS_REQUEST_EMAIL_VERIFICATION',
}
